import React, { useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { CustomButton } from '../../../../../components/Button/Button'
import { useWorkflowById } from '../../../../../utils/reactQuery/workflows'
import { updateWorkflowStep } from '../../../../../sevices/apiCards'
import useMutate from '../../../../../hooks/useMutate'

function MoveQuickToRegularTask({ cardDetail, cardId }) {
    const queryClient = useQueryClient()

    // Get workflow_id and board_id from cardDetail
    const { board_id, workflow_id } = useMemo(() => ({
        board_id: cardDetail?.board?.board_id || cardDetail?.board_id,
        workflow_id: cardDetail?.board?.workflow_id,
    }), [cardDetail])

    // Fetch workflow steps
    const { data: workflowData } = useWorkflowById(workflow_id, board_id)

    // Find the first workflow step (lowest step_sequence)
    const firstWorkflowStepId = useMemo(() => {
        if (!workflowData?.data?.data?.responseData) {
            return null
        }
        const workflowSteps = workflowData.data.data.responseData
        if (workflowSteps.length === 0) {
            return null
        }
        // Sort by step_sequence and get the first one
        const sortedSteps = [...workflowSteps].sort((a, b) => a.step_sequence - b.step_sequence)
        return sortedSteps[0]?.workflow_step_id || null
    }, [workflowData])

    // Setup mutation for updating workflow step
    const { mutate: updateMutate, isPending } = useMutate(
        updateWorkflowStep,
        ['watching', 'mineCards'],
        () => {},
        () => {
            // Invalidate queries on success
            queryClient.invalidateQueries({
                queryKey: [`cards`, board_id],
            })
            queryClient.invalidateQueries({
                queryKey: [`history`, String(cardId)],
            })
            queryClient.invalidateQueries({
                queryKey: [`card`, cardId],
            })
        },
        () => {}
    )

    const handleAnchorClick = () => {
        if (!firstWorkflowStepId) {
            console.error('First workflow step not found')
            return
        }
        
        updateMutate({
            card_id: cardId,
            workflow_step_id: firstWorkflowStepId,
        })
    }

    return (
        <div>
            <CustomButton
                variant="outlined"
                color="primary"
                id="epics-board-dropdown"
                aria-haspopup="true"
                onClick={handleAnchorClick}
                disabled={!firstWorkflowStepId || isPending}
                className="white-button change-board-btn capitalize">
                Convert to Task
            </CustomButton>
        </div>
    )
}

export default MoveQuickToRegularTask